import { getABTProvider } from '@/plugins/abt/statsig'
import { isFeatureEnabledSafe } from '@/utils/abt'

const abtProvider = getABTProvider()

/** Statsig gate — enable `use_cosmos_flutter` Mobile.postMessage for the WebView bridge */
const COSMOS_FLUTTER_MOBILE_GATE = 'cosmos_flutter_native_enabled'

export const sendMessage = (orderId, source, action) => {
  try {
    if (!mobileBridgeIsActive()) {
      return
    }

    Mobile?.postMessage(
      JSON.stringify({
        payload: {
          source,
          order_id: orderId,
        },
        action,
      })
    )
  } catch (err) {
    console.error(err)
  }
}

export const notifyUseCosmosFlutter = (checkoutId) => {
  try {
    if (!mobileBridgeIsActive() || !checkoutId) {
      return
    }

    if (!isFeatureEnabledSafe(abtProvider, COSMOS_FLUTTER_MOBILE_GATE)) {
      return
    }

    Mobile?.postMessage(
      JSON.stringify({
        payload: {
          checkout_id: checkoutId,
        },
        action: 'use_cosmos_flutter',
      })
    )
  } catch (err) {
    console.error(err)
  }
}

const mobileBridgeIsActive = () => {
  try {
    return !!Mobile
  } catch (err) {
    return false
  }
}
